/*
  Unknown Ink cart drawer extras
  - Keeps the free e-book in the cart whenever a Photography Set / PRO / Extension Pack is in it (removes it otherwise)
  - "Complete your order" add buttons
  - 10% unlock message, with the $139 threshold converted to the shopper's currency
*/
(() => {
  const CFG = window.UI_CART || {};
  const GIFT_ID = Number(CFG.giftVariantId);
  const QUALIFYING = (CFG.qualifyingProductIds || []).map(Number);
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const origFetch = window.fetch.bind(window);
  let busy = false;
  let timer = null;

  const isCartMutation = (url) => /\/cart\/(add|change|update|clear)(\.js)?/.test(url || '');

  async function getCart() {
    const r = await origFetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function post(path, body) {
    return origFetch(`${ROOT}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  async function refreshDrawer() {
    const r = await origFetch(`${ROOT}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await r.json();
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const fresh = doc.querySelector('#CartDrawer');
      const current = document.querySelector('#CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const freshDrawer = doc.querySelector('cart-drawer');
      if (freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      document.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    updateStatus();
  }

  // The theme's own refresh after "add to cart" doesn't re-render the footer add-ons,
  // so refresh that slot ourselves after every cart change.
  async function refreshUpsellSlot() {
    const slot = document.querySelector('[data-ui-upsell-slot]');
    if (!slot) return;
    const r = await origFetch(`${ROOT}?sections=cart-drawer`);
    const sections = await r.json();
    if (!sections['cart-drawer']) return;
    const fresh = new DOMParser()
      .parseFromString(sections['cart-drawer'], 'text/html')
      .querySelector('[data-ui-upsell-slot]');
    if (fresh && fresh.innerHTML !== slot.innerHTML) slot.innerHTML = fresh.innerHTML;
    updateStatus();
  }

  async function syncGift() {
    if (!GIFT_ID || busy) return;
    busy = true;
    try {
      const cart = await getCart();
      const gift = cart.items.find((i) => i.variant_id === GIFT_ID);
      const qualifies = cart.items.some((i) => QUALIFYING.includes(i.product_id));
      let changed = false;

      if (qualifies && !gift) {
        await post('cart/add.js', { items: [{ id: GIFT_ID, quantity: 1 }] });
        changed = true;
      } else if (!qualifies && gift) {
        await post('cart/change.js', { id: gift.key, quantity: 0 });
        changed = true;
      } else if (gift && gift.quantity > 1) {
        await post('cart/change.js', { id: gift.key, quantity: 1 });
        changed = true;
      }
      if (changed) await refreshDrawer();
      else await refreshUpsellSlot();
    } catch (e) {
      console.warn('[cart extras] gift sync failed', e);
    } finally {
      busy = false;
    }
  }

  const scheduleSync = () => {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 400);
  };

  // Catch every cart change: theme, GemPages, Kaching, anything using fetch or XHR.
  window.fetch = async function (...args) {
    const res = await origFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
      if (isCartMutation(url) && res.ok) scheduleSync();
    } catch (e) {}
    return res;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (isCartMutation(String(url))) this.addEventListener('load', scheduleSync);
    return xhrOpen.call(this, method, url, ...rest);
  };

  // 10% unlock message
  // Format like the theme does ("1 234,56 kr", "$1,234.56", "€1.234,56"), learned from a sample
  // the theme rendered for 1,234,567.89 in the shopper's currency.
  function formatMoney(cents) {
    const sample = document.querySelector('[data-ui-upsell]')?.dataset.uiMoneySample || '';
    const m = sample.match(/^(.*?)1(\D?)234(?:\2)567(\D)89(.*)$/s);
    if (m) {
      const [, prefix, thousands, decimal, suffix] = m;
      const fixed = (Math.max(0, cents) / 100).toFixed(2).split('.');
      const int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return `${prefix}${int}${decimal}${fixed[1]}${suffix}`;
    }
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function updateStatus() {
    const box = document.querySelector('[data-ui-upsell]');
    const el = box && box.querySelector('[data-ui-status]');
    if (!el) return;
    const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
    const threshold = Math.round(Number(box.dataset.uiThreshold) * rate);
    const subtotal = Number(box.dataset.uiSubtotal);
    const paidCount = Number(box.dataset.uiPaidCount);

    let text;
    if (subtotal < threshold) {
      text = `Spend ${formatMoney(threshold - subtotal)} more and get 10% off an extra item`;
    } else if (paidCount <= 1) {
      text = 'Unlocked: add one more item and get 10% off it';
    } else {
      text = '10% off unlocked on your extra item';
    }
    if (el.textContent !== text) el.textContent = text;
    box.classList.toggle('is-unlocked', subtotal >= threshold);
  }

  // Upsell add buttons + variant pickers
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-ui-variant]');
    if (!select) return;
    const card = select.closest('[data-ui-card]');
    const btn = card.querySelector('[data-ui-add]');
    if (btn) btn.dataset.variantId = select.value;
    const price = card.querySelector('[data-ui-price]');
    const opt = select.options[select.selectedIndex];
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  // Add-on arrows: move one card at a time
  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-ui-prev], [data-ui-next]');
    if (!nav) return;
    const track = nav.closest('[data-ui-upsell]').querySelector('[data-ui-track]');
    const card = track && track.querySelector('[data-ui-card]');
    if (!card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    const dir = nav.hasAttribute('data-ui-next') ? 1 : -1;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    if (dir === 1 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
    else track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ui-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');
    try {
      const res = await post('cart/add.js', { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add item');
      await refreshDrawer();
      await syncGift();
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.setAttribute('aria-label', 'Unavailable');
      btn.classList.add('is-error');
      console.warn('[cart extras]', err);
    }
  });

  // The theme re-renders the drawer after quantity changes: keep the status line filled.
  const observeDrawer = () => {
    const target = document.getElementById('CartDrawer');
    if (!target) return;
    new MutationObserver(updateStatus).observe(target, { childList: true, subtree: true });
  };

  const init = () => {
    observeDrawer();
    updateStatus();
    syncGift();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
